import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { GAP_CLASS, type Align, type Gap, type Justify } from "./tokens";

export interface GroupProps extends HTMLAttributes<HTMLDivElement> {
  gap?: Gap;
  align?: Align;
  justify?: Justify;
  /** Igual que Mantine: por default los hijos SÍ envuelven (`"wrap"`). */
  wrap?: "wrap" | "nowrap";
}

/**
 * Reemplazo de `<Group>` de Mantine · fila flex con `gap`. Mismas props que
 * el original (`justify="space-between"` es, por lejos, el uso más común
 * en el repo) para minimizar el diff al migrar cada call-site.
 */
export const Group = forwardRef<HTMLDivElement, GroupProps>(
  (
    { gap = "md", align = "center", justify, wrap = "wrap", className, style, ...props },
    ref
  ) => (
    <div
      ref={ref}
      className={cn(
        "flex flex-row",
        wrap === "wrap" ? "flex-wrap" : "flex-nowrap",
        typeof gap === "string" ? GAP_CLASS[gap] : undefined,
        className
      )}
      style={{
        alignItems: align,
        justifyContent: justify,
        ...(typeof gap === "number" ? { gap } : undefined),
        ...style,
      }}
      {...props}
    />
  )
);
Group.displayName = "Group";
